
























































































import { Component, Prop, Emit } from 'nuxt-property-decorator'
import {
  DataTable,
  BODY_HEIGHT,
  Col,
  DataTableHeader
} from '@/components/molecules/DataTable'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'
import { SystemCodeAddress } from '@/api'

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    items: [
      {
        name: 'code',
        headerText: '住所コード'
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    items: [
      {
        name: 'areaCode',
        headerText: '地区コード'
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    items: [
      {
        name: 'zipCode',
        headerText: '郵便番号'
      }
    ]
  },
  {
    width: '55',
    resizable: true,
    items: [
      {
        name: 'name',
        headerText: '住所'
      }
    ]
  }
]

@Component({
  components: {
    DataTable,
    DataTableHeader,
    RecycleScroller
  }
})
export default class CodeAddressTable extends DataTable {
  @Prop({
    type: Array,
    required: true
  })
  items!: SystemCodeAddress[]

  @Prop({
    type: Object,
    required: true
  })
  selected!: SystemCodeAddress

  @Prop({
    type: Number,
    default: BODY_HEIGHT
  })
  height!: number

  get showCols(): Col[] {
    return COLS
  }

  @Emit('click:row')
  onClickTableRow(index: number): number {
    return index
  }

  @Emit('dblclick:row')
  onDblclickRow(): void {}
}
